import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "lib/utils";

const badgeVariants = cva(
    "tw-inline-flex tw-items-center tw-rounded tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium",
    {
        variants: {
            variant: {
                default: "tw-bg-neutral-100 tw-text-neutral-400",
                active: "tw-bg-status-success tw-text-status-success-text",
                inactive: "tw-bg-status-error tw-text-status-error-text",
                warning: "tw-bg-status-warning tw-text-status-warning-text",
                info: "tw-bg-status-info tw-text-status-info-text",
                accent: "tw-bg-brand-teal/10 tw-text-brand-teal",
                count: "tw-bg-brand-dark tw-text-white tw-rounded-full tw-min-w-[1.25rem] tw-justify-center",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

function Badge({ className, variant, ...props }) {
    return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
